import { createFetch } from '@vueuse/core';

/**
 * Resolves the API base URL exclusively from `window.env.VITE_BACK_URL`,
 * which must be injected by the runtime `/env.js` script (see `index.html`).
 *
 * The previous implementation silently fell back to a hardcoded HTTP IP
 * (`http://91.108.184.57`) when `env.js` failed to load. That was a security
 * footgun: any deployment glitch routed every API call to that address in
 * cleartext, including signed presigned URLs and customer data. We prefer
 * fail-fast — a deployment problem must be visible, not silently routed
 * somewhere else.
 */
function getApiUrl(): string {
    if (typeof window === 'undefined') {
        throw new Error(
            '[useFetchInstanceBasic] window is undefined; this module must run in the browser.'
        );
    }

    const raw = window.env?.VITE_BACK_URL;
    if (!raw) {
        // eslint-disable-next-line no-console
        console.error(
            '[useFetchInstanceBasic] window.env.VITE_BACK_URL is missing. ' +
                'env.js failed to load. The customizer cannot reach its backend.'
        );
        throw new Error('VITE_BACK_URL is required (env.js failed to load)');
    }

    let apiUrl = raw;
    if (!apiUrl.startsWith('http://') && !apiUrl.startsWith('https://')) {
        apiUrl = `https://${apiUrl}`;
    }
    return apiUrl;
}

export const useFetchInstanceBasic = createFetch({
    baseUrl: getApiUrl(),
    combination: 'chain'
});
